import React from 'react';
import { List, Tag, Typography, Card, Flex, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedOffer } from '../../../redux/offerEngine';
import { CheckCircleFilled } from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;

const SelectableOffers = ({ data = [] }) => {
  const { isMobileView } = useSelector((store) => store.appConfigInfo);
  const { selectedOffer } = useSelector((store) => store.offerEngine);
  const dispatch = useDispatch();

  const handleApply = (offer) => {
    const paymentMode = offer?.payment_modes?.[0]?.payment_mode || null;

    let method = '';
    if (paymentMode === 'credit_card') method = 'CARD';
    else if (paymentMode === 'debit_card') method = 'CARD';
    else if (paymentMode === 'upi') method = 'UPI';

    if (method) {
      dispatch(
        setSelectedOffer({
          open: true,
          offerId: offer?.id,
          offerMethod: method,
          offerTitle: offer?.title,
        })
      );
    }
  };

  return (
    <div style={{ margin: '0 auto' }}>
      <div
        style={{
          maxHeight: 320,
          overflowY: 'auto',
          paddingRight: 8,
        }}
        className="custom-scroll"
      >
        <List
          dataSource={data}
          renderItem={(item) => {
            const paymentMode = item?.payment_modes?.[0]?.payment_mode;
            const isSelected =
              selectedOffer?.offerId === item?.id &&
              selectedOffer?.offerMethod === (paymentMode === 'credit_card' ? 'CARD' : 'UPI');

            return (
              <Card
                key={item.id}
                hoverable
                onClick={() => handleApply(item)}
                style={{
                  overflow: 'hidden',
                  marginBottom: 12,
                  borderRadius: 8,
                  border: isSelected
                    ? '1px solid #1677ff'
                    : '1px solid #f0f0f0',
                  background: isSelected ? '#f0f7ff' : '#fff',
                  boxShadow: isSelected
                    ? '0 2px 8px rgba(22, 119, 255, 0.15)'
                    : '0 1px 4px rgba(0,0,0,0.06)',
                  cursor: 'pointer',
                  transition: 'all 0.25s ease',
                }}
                bodyStyle={{ padding: 0 }}
              >
                <Flex align="stretch">
                  {/* Left Section */}
                  <Flex
                    vertical
                    align="center"
                    justify="center"
                    style={{
                      width: isMobileView ? 80 : 120,
                      background: '#fafafa',
                      padding: 12,
                      borderRight: '1px solid #f0f0f0',
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 10,
                        color: '#8c8c8c',
                        fontWeight: 600,
                      }}
                    >
                      PROVIDER
                    </Text>

                    <Text strong style={{ fontSize: 13, textAlign: 'center' }}>
                      {item?.provider_code}
                    </Text>

                    {item?.code && (
                      <Tag
                        color="blue"
                        style={{ marginTop: 8, marginInlineEnd: 0 }}
                      >
                        {item.code}
                      </Tag>
                    )}
                  </Flex>

                  {/* Right Section */}
                  <div style={{ flex: 1, padding: 16 }}>
                    {/* Title + Button Row */}
                    <Flex
                      justify="space-between"
                      align={isMobileView ? 'flex-start' : 'center'}
                      vertical={isMobileView}
                      gap={8}
                    >
                      <Title
                        level={5}
                        style={{
                          margin: 0,
                          fontSize: 14,
                          lineHeight: 1.4,
                        }}
                      >
                        {item?.title}
                      </Title>

                      {isSelected && (
                        <Button
                          type="primary"
                          icon={<CheckCircleFilled />}
                          style={{
                            width: isMobileView ? '100%' : 'auto',
                          }}
                        >
                          Applied
                        </Button>
                      )}
                    </Flex>

                    {/* Description */}
                    <Paragraph
                      type="secondary"
                      ellipsis={{ rows: 2 }}
                      style={{
                        marginTop: 6,
                        marginBottom: 0,
                        fontSize: 13,
                      }}
                    >
                      {item?.description || ''}
                    </Paragraph>
                  </div>
                </Flex>
              </Card>
            );
          }}
        />
      </div>
    </div>
  );
};

export default SelectableOffers;